import { keyframes } from '@emotion/css'
import styled from '@emotion/styled'
import { zIndex, colors } from 'component-library/__styling/settings'
import { breakpoint, calcRem } from 'component-library/__styling/style-functions'
import { conditionalStyles } from 'component-library/__styling/conditional-styles'

const navHeight = 50

interface StickyProps {
    height: number
    isHidden: boolean
    scrollUp: boolean
    isTop: boolean
}

export const StyledNavigation = styled('div')<StickyProps>(props => ({
    [breakpoint('md')]: {
        position: 'sticky',
        zIndex: zIndex.thewest.stickySiteHeader,
        top: props.height,

        animationTimingFunction: 'linear',
        animationDuration: '200ms',
        animationFillMode: 'forwards',

        // Prevents animations
        ...conditionalStyles(props.isTop, {
            animation: 'none',
            transform: 'translateY(0)',
        }),

        // Animation to Hide once past scroll threshold
        ...conditionalStyles(props.isHidden, {
            transform: 'translateY(0)',
            animationName: keyframes({
                '0%': { transform: 'translateY(0)' },
                '100%': { transform: `translateY(-${props.height + navHeight}px)` },
            }),
        }),

        ...conditionalStyles(!props.isHidden && !props.isTop, {
            transform: `translateY(-${props.height + navHeight}px)`,
            animationName: keyframes({
                '0%': { transform: `translateY(-${props.height + navHeight}px)` },
                '100%': { transform: 'translateY(0)' },
            }),
        }),
    },
}))

//TODO: After test has run merge with current StyledAd
// These are currently different due to slightly different style requirements
export const StyledAd = styled('div')<StickyProps>(
    {
        display: 'none',

        [breakpoint('sm')]: {
            background: colors.thewest.greyErmine,
            display: 'block',
            position: 'relative',
            overflow: 'hidden',
            /** leaderboardBillboard ad unit on The West has paddingBottom applied when
             *  ad unit is displaying leaderboard size
             */
            paddingBottom: calcRem(13),

            '&::after': {
                content: `''`,
                boxShadow: `0 ${calcRem(1)} ${calcRem(16)} 0 ${colors.black35}`,
                height: calcRem(10),
                position: 'absolute',
                bottom: -10,
                opacity: 1,
                width: '100%',
            },
        },

        /** remove padding when we're displaying the billboard ad */
        '@media screen and (min-width: 970px )': {
            paddingBottom: 0,
        },
    },
    props => ({
        [breakpoint('md')]: {
            position: 'sticky',
            zIndex: zIndex.thewest.stickySiteHeader,
            top: 0,

            animationTimingFunction: 'linear',
            animationDuration: '200ms',
            animationFillMode: 'forwards',

            // Stop it from animating
            ...conditionalStyles(props.isTop, {
                animation: 'none',
                transform: 'translateY(0)',
            }),

            // Animation to Hide once past scroll threshold
            ...conditionalStyles(props.isHidden, {
                transform: 'translateY(0)',
                animationName: keyframes({
                    '0%': { transform: 'translateY(0)' },
                    '100%': { transform: `translateY(-${props.height}px)` },
                }),
            }),

            // Animation to animate back in on scroll up
            ...conditionalStyles(!props.isHidden && !props.isTop, {
                animationName: keyframes({
                    '0%': {
                        transform: `translateY(-${props.height}px)`,
                    },
                    '100%': {
                        transform: 'translateY(0)',
                    },
                }),
            }),
        },
    })
)

export const StyledHeaderContainer = styled('div')({
    background: colors.white,
})
